import * as React from 'react';
import { scrollToAnchor } from '@cian/newbuilding-utils';

import { useMapPreviewUrl } from './hooks/useMapPreviewUrl';
import { MapPreview } from '../../components/MapPreview';
import { MapPreviewOnboardingContainer } from '../MapPreviewOnboardingContainer';

export function MapPreviewContainer() {
  const mapPreview = useMapPreviewUrl();

  if (!mapPreview) {
    return null;
  }

  const onClick = (event: React.MouseEvent<HTMLElement>) => {
    scrollToAnchor({
      anchor: '#infrastructure',
      offset: 0,
      hasRelocation: false,
      hasAnimation: true,
    })(event);
  };

  return (
    <MapPreviewOnboardingContainer onClick={onClick}>
      <MapPreview mapPreview={mapPreview} onClick={onClick} />
    </MapPreviewOnboardingContainer>
  );
}
